module.exports = __webpack_public_path__ + "img/404.3e104ed8.png";